import CookieService from '../../../../Utils/CookieService';
export const getAuthToken = () => {
    return CookieService.get("token") || CookieService.get("token"); // Fallback to empty string if token is missing
  };
  
  export const getAuthHeaders = () => {
    return {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: `Bearer ${getAuthToken()}`,
    };
  };
  